export default __webpack_public_path__ + "static/media/step-middle-inactive.20c922ab.png";